import { GET_SECTION_PRICES_FAIL, GET_SECTION_PRICES_REQUEST, GET_SECTION_PRICES_SUCCESS, SET_REGION, SET_REGION_SUGGESTION } from "../types";

export const setRegion = (code: string) => ({
    type: SET_REGION as typeof SET_REGION,
    payload: code,
});

export const setRegionSuggestion = (code: string | null) => ({
    type: SET_REGION_SUGGESTION as typeof SET_REGION_SUGGESTION,
    payload: code,
});

export const getSectionPricesRequest = (region: string, productIds: string[]) => ({
    type: GET_SECTION_PRICES_REQUEST as typeof GET_SECTION_PRICES_REQUEST,
    payload: { region, productIds },
});

export const getSectionPricesSuccess = () => ({
    type: GET_SECTION_PRICES_SUCCESS as typeof GET_SECTION_PRICES_SUCCESS,
});

export const getSectionPricesFail = (error: any) => ({
    type: GET_SECTION_PRICES_FAIL as typeof GET_SECTION_PRICES_FAIL,
    payload: { error },
});
